export const fmtBytes = (b) => {
  if (b == null) return "";
  if (b < 1024) return `${b} B`;
  if (b < 1048576) return `${(b / 1024).toFixed(0)} KB`;
  return `${(b / 1048576).toFixed(1)} MB`;
};

export const imageDims = (file) =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      resolve({ w: img.naturalWidth, h: img.naturalHeight });
      URL.revokeObjectURL(url);
    };
    img.onerror = () => {
      resolve(null);
      URL.revokeObjectURL(url);
    };
    img.src = url;
  });

export const ytId = (url) => {
  if (!url) return "";
  const s = String(url).trim().replace(/^["']|["']$/g, "");
  if (s.startsWith("http")) {
    const m = s.match(/(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/|e\/)|youtu\.be\/|youtube\.com\/.*[?&]v=)([A-Za-z0-9_-]{11})/);
    return m ? m[1] : "";
  }
  return /^[A-Za-z0-9_-]{11}$/.test(s) ? s : "";
};
